import { css } from 'aphrodite';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { styleSheet } from '../CompactLogoIcon/styles';

interface IProps {
	className?: string;
	height?: number;
	loading?: boolean;
	width?: number;
}

/**
 * Cambridge Source Marketing compact logo
 * Uses the Cambridge wave graphic as the compact representation
 */
export const CambridgeCompactLogoIcon = ({ className, height = 40, loading = false, width = 40 }: IProps) => {
	const [isHovering, setIsHovering] = useState<boolean>(false);
	const [isLoaded, setIsLoaded] = useState<boolean>(false);

	useEffect(() => {
		if (loading && !isLoaded) {
			const timeoutId = setTimeout(() => {
				setIsLoaded(true);
			}, 800);

			return () => clearTimeout(timeoutId);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='4 10 44 20'
			className={`cambridge-compact-logo-icon-2023 ${className ?? ''} ${clsx(
				css(loading ? styleSheet.topLayer : undefined),
				css(isHovering ? styleSheet.hovering : undefined),
				css(loading && isLoaded ? styleSheet.loading : undefined)
			)}`}
			onMouseOver={() => setIsHovering(true)}
			onMouseOut={() => setIsHovering(false)}
		>
			{loading && <title>Loading...</title>}
			<defs>
				<clipPath id='clippath-compact'>
					<path d='M4.1 10.7H50v18.6H4.1z' style={{ fill: 'none' }} />
				</clipPath>
			</defs>
			<path
				d='M37.2 17.1c-1.7.6-6.6 2-13.6-.7-4.4-1.7-7.8-1.3-10.3-.1l-1.7 2.2c2.5-.8 6.4-1.4 11.6.4 5.6 2.2 9.9 1.3 11.9.4l2-2.2Z'
				fill='#fff'
			/>
			<g style={{ clipPath: 'url(#clippath-compact)' }}>
				<path
					d='M33.6 21.7c-1.7.6-6.5 1.8-13.6-.7-4.5-1.5-7.9-1.2-10.3 0l-1.6 2.1c2.5-.7 6.6-1.4 11.6.4 6.1 2.2 9.9 1.3 11.9.4l2-2.1ZM30 26.3c-1.9.8-6.2 1.7-13.5-.7-4.8-1.7-8.2-.8-10.6.3l-1.8 2.5c1.7-1.7 7.1-2.1 12.2-.4 6.3 2.1 9.9 1.3 11.9.4l1.9-2.2ZM41 12.6c-1.9.5-7 1.5-13.6-.8-4.6-1.7-8-1.3-10.5 0l-1.8 2.1c3.2-1.4 6.8-1.4 11.9.5 5.6 2.1 9.5 1 11.6.3l2.5-2.2Z'
					fill='#fff'
				/>
			</g>
		</svg>
	);
};
